function heatmapWrapper() {
    return {
        componentName: 'heatmapWrapper',
        baseStyle: {
            overflowX: 'auto'
        }
    };
}

export { heatmapWrapper as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVhdG1hcFdyYXBwZXIuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9jb21wb25lbnRzL2hlYXRtYXAvaGVhdG1hcFdyYXBwZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ29tcG9uZW50U3R5bGUgfSBmcm9tICcuLi8uLi8uLi90aGVtZS90eXBlcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGhlYXRtYXBXcmFwcGVyKCk6IENvbXBvbmVudFN0eWxlIHtcbiAgcmV0dXJuIHtcbiAgICBjb21wb25lbnROYW1lOiAnaGVhdG1hcFdyYXBwZXInLFxuICAgIGJhc2VTdHlsZToge1xuICAgICAgb3ZlcmZsb3dYOiAnYXV0bydcbiAgICB9XG4gIH07XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWMsU0FBVSxjQUFjLEdBQUE7SUFDcEMsT0FBTztBQUNMLFFBQUEsYUFBYSxFQUFFLGdCQUFnQjtBQUMvQixRQUFBLFNBQVMsRUFBRTtBQUNULFlBQUEsU0FBUyxFQUFFO0FBQ1o7S0FDRjtBQUNIOzs7OyJ9
